<template lang="pug">
v-flex(xs6 sm3)
  v-card(ripple elevation="1" :to="to" :href="href" :target="target")
    v-card-title.Zjustify-center.pb-2
      .Ztext-xs-center.subheading
        
        v-badge(Zoverlap color="red")
          v-icon.mr-2(:color="iconColor") {{ icon }}
          | {{ title }}
          template(slot="badge" v-if="bagdeCount")
            span {{ bagdeCount }}
          //- v-avatar(:color="iconColor")
            v-icon(dark) {{ icon }}
      
    v-card-text.pt-0
      v-divider.mb-2
      .caption.Ztext-xs-center.grey--text(style="height: 36px;") {{ subtitle }}
</template>

<script>
export default {
  name: 'HomeCard',
  props: {
    to: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconColor: {
      type: String,
      default: null,
    },
    bagdeCount: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
  },

  data() {
    return {

    }
  },

}
</script>

<style lang="stylus">
</style>


// WEBPACK FOOTER //
// src/components/home/HomeCard.vue